<template>
    <div class="t-mobile-items mobile-items">
        <slot name="header"/>
        <div class="mobile-items__control" v-if="isControls">
            <svg-icon
                original
                name="icons/arrow-up"
                class="mobile-items__control-icon"
            />
        </div>
        <slot name="container"/>
        <div class="mobile-items__control" v-if="isControls">
            <svg-icon
                original
                name="icons/arrow-down"
                class="mobile-items__control-icon"
            />
        </div>
        <footer
            v-if="isFooter"
            :class="[
                'mobile-items__footer',
                {'mobile-items__footer--landscape': isLandscape},
                {'mobile-items__footer-off': !sortingPanel && isLandscape}]"
            :style="{'background-color': isLandscape ? color : ''}"
        >
            <AMBackButton
                v-if="!isLandscape"
                :text="footerButtonText"
                :theme="theme"
                @onClick="handleFooterClickBack"
            />
            <OMSortingPanel
                v-else-if="sortingPanel"
                :value="localValue"
                :defined-buttons="sortingButtons"
                @onClick="handleClick"
            />
        </footer>
        <MIndexPanel
            v-if="indexPanel"
            :value="currentLetterIndexPanel"
            :active-buttons="activeButtons"
            @clickLetter="handleClickLetter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
    
import MIndexPanel from '../../molecules/m-index-panel/m-index-panel';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OMSortingPanel from '../../organisms/o-m-sorting-panel/o-m-sorting-panel';

export default {
    name: 'TMobileItems',
    data() {
        return {
            sortBy: 'All'
        }
    },
    components: {
        MIndexPanel,
        AMBackButton,
        OMSortingPanel
    },
    props: {
        activeButtons: {
            type: Array,
            default: () => []
        },
        indexPanel: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'close'
        },
        footerButtonText: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        /**
         * Value for v-model use
         */
        value: {
            type: String,
            default: ''
        },
        sortingButtons: {
            type: Array,
            default: () => []
        },
        currentLetterIndexPanel: {
            type: String,
            default: ''
        },
        sortingPanel: {
            type: Boolean,
            default: false
        },
        isControls: {
            type: Boolean,
            default: true
        },
        isFooter: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        handleFooterClickBack() {
            this.$emit('onFooterButton', true);
        },
        handleClick(value) {
            this.localValue = value;
        },
        handleClickLetter(evt) {
            this.$emit('clickLetter', evt);
        }
    }
}
</script>

<style lang="scss">
@import "t-mobile-items";
</style>